export default __webpack_public_path__ + "static/media/gallery-img5.36b09cdc.jpeg";